export default "__VITE_ASSET__Dd$0wywh__"